<template>
  <div class="header" v-bind:class="{ myclassZ: (currentMenu != '') }">
	<topbar></topbar>
	<template>
		<div class="header-menu">
		<b-container  class="pl-0 pr-0">
		  <b-navbar toggleable="lg" type="light" >
			
			<b-row class="menumobile d-md-none">
			<b-col cols="2" class="py-2">
				<!--<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
				<b-navbar-toggle target="menuPanel" v-b-toggle.menuPanel></b-navbar-toggle>-->
				<b-navbar-toggle target="menuWeb" v-b-toggle.menuWeb></b-navbar-toggle>
			</b-col>
			<b-col cols="4" class="pl-0 py-2">
				<b-navbar-brand href="/" v-b-toggle.sidebar-1>
					<b-img :src="$root.MEDIAPATH+'images/logo.png'"></b-img>
				</b-navbar-brand>
			</b-col>
			<b-col cols="6" class="p-0 userPael">
				<b-navbar-nav class="ml-auto">
					
					<b-nav-item v-if="$root.cart.quantity==0" class="shopping-basket  clickToCart" v-b-toggle.cartPanel @mouseover="onLeave"  ><b-img src="../assets/shopping-cart.svg" class="icon p-0 "></b-img><span>{{$root.cart.quantity}}</span></b-nav-item>
					<b-nav-item  v-else class="shopping-basket clickToCart" v-b-toggle.cartPanel @mouseover="onLeave" ><b-img src="../assets/shopping-cart.svg" class="icon p-0 "></b-img><span>{{$root.cart.quantity}}</span></b-nav-item>


					<b-nav-item v-if="$root.customer_info.user_id>0 && $root.customer_info.role !=3" :href="wishlistUrl"  @mouseover="onLeave" class="mr-0 clickToWishlist"><b-icon icon="heart" aria-hidden="true"></b-icon>  </b-nav-item>
					
					<b-nav-item  v-if="$root.customer_info.role==3 "  class="shopping-basket mt-0" v-b-toggle.cartShop @mouseover="onLeave"  ><b-icon class="py-0 " icon="bag" aria-hidden="true" ></b-icon> <i class="bi bi-bag"></i> <span>{{$root.share.shareitems.length}}</span>
					</b-nav-item>
					<b-nav-item v-if="$root.customer_info.user_id == 0" href="/login" class="m-0 userheader mt-0"  >
							  <b-icon class="py-0 mr-0" icon="person" aria-hidden="true" ></b-icon>
							 </b-nav-item>
							<b-nav-item-dropdown right class="header-customdd mt-0"  @mouseover="onLeave" v-else>
							  <template v-slot:button-content @mouseover="onLeave"> 
								<em style="font-size: 21px;" > 
								<b-icon class="py-0 mr-0" icon="person" aria-hidden="true" @mouseover="onLeave" ></b-icon></em>
								<!--<em v-if="$session.get('customer_info')">{{$root.customer_info.custname}}</em> -->
							  </template>  				   
								
							  <span v-if="$root.customer_info.role==4">
								<b-dropdown-item href="/customer/dashboard" class="mx-2">My Account</b-dropdown-item>
								<b-dropdown-item href="/customer/wallet">My Wallet</b-dropdown-item>
								<b-dropdown-item href="#" v-b-modal="'cp-modal'">Change Password</b-dropdown-item>
								<b-dropdown-item href="/faq" >FAQs</b-dropdown-item>
								<b-dropdown-item href="/survey" >Feedback Form</b-dropdown-item>
								<b-dropdown-item href="/videos" >Watch & Buy</b-dropdown-item>
								<b-dropdown-item href="/logout" class="ml-2" >Logout</b-dropdown-item>
							  </span>
							  <span v-if="$root.customer_info.role==3">
								<b-dropdown-item :href="'/'+$root.INFLUENCER+'/dashboard'" class="mx-2">My Account</b-dropdown-item>
								<b-dropdown-item :href="'/'+$root.INFLUENCER+'/my-shop'" class="mx-2">My Shop</b-dropdown-item>
								<b-dropdown-item :href="'/'+$root.INFLUENCER+'/wishlist'" class="mx-2">My Wishlist</b-dropdown-item>
								<b-dropdown-item href="#" v-b-modal="'cp-modal'">Change Password</b-dropdown-item>
								<b-dropdown-item href="/faq" >FAQs</b-dropdown-item>
								<b-dropdown-item href="/survey" >Feedback Form</b-dropdown-item>
								<b-dropdown-item href="/videos" >Watch & Buy</b-dropdown-item>
								<b-dropdown-item href="/logout" class="ml-2" >Logout</b-dropdown-item>
							  </span>
							   <span v-if="$root.customer_info.role==2">
								<b-dropdown-item href="/seller/dashboard" class="mx-2">My Account</b-dropdown-item>
								<b-dropdown-item href="#" v-b-modal="'cp-modal'">Change Password</b-dropdown-item>
								<b-dropdown-item href="/faq" >FAQs</b-dropdown-item>
								<b-dropdown-item href="/survey" >Feedback Form</b-dropdown-item>
								<b-dropdown-item href="/seller/videos" >Upload Videos</b-dropdown-item>
								<b-dropdown-item href="/logout" class="ml-2" >Logout</b-dropdown-item>
							  </span>
							   <span v-if="$root.customer_info.role==1">
								<b-dropdown-item href="/admin/dashboard" class="mx-2">My Account</b-dropdown-item>
								<b-dropdown-item href="#" v-b-modal="'cp-modal'">Change Password</b-dropdown-item>
								<b-dropdown-item href="/faq" >FAQs</b-dropdown-item>
								<b-dropdown-item href="/survey" >Feedback Form</b-dropdown-item>
								<b-dropdown-item href="/videos" >Watch & Buy</b-dropdown-item>
								<b-dropdown-item href="/logout" class="ml-2" >Logout</b-dropdown-item>
							  </span>
							 </b-nav-item-dropdown>
				</b-navbar-nav>
			</b-col>
			</b-row>
			 
			<!-- <b-navbar-brand href="/" v-b-toggle.sidebar-1 class="d-none d-md-block">
			  <b-img :src="$root.MEDIAPATH+'images/logo.png'"></b-img>
			</b-navbar-brand> -->
			<b-navbar-brand href="/" v-b-toggle.sidebar-1 class="d-none d-md-block">
			  <b-img :src="$root.MEDIAPATH+'images/logo_alluraa.png'" class="logoSmall" v-if="!showSmallLogo"></b-img>  
			
				<b-link v-else class="allsideMenu" v-b-toggle.menuWeb @click="clickHandler()"><b-icon icon="list" aria-hidden="true"></b-icon> All </b-link>
			</b-navbar-brand>

			

			<b-collapse id="nav-collapse" is-nav class="d-none d-md-block">
			  <b-navbar-nav>
				<!--<b-nav-item href="#">Link</b-nav-item>-->
			  </b-navbar-nav>

			  <!-- Right aligned nav items -->
			  <b-navbar-nav class="ml-auto f-sb">
				
			   <!-- <mega-menu></mega-menu>-->
				<!--<b-nav-item href="/fashion/fashion-women">Women's Fashion </b-nav-item>
				
				
				<b-nav-item href="/fashion/fashion-men" text="Fashion"   v-bind:class="{ active: (currentMenu == 'menu-1') }">Men's Fashion </b-nav-item>
				<b-nav-item href="/makeup" text="Cosmetics" v-bind:class="{ active: (currentMenu == 'menu-2') }">Makeup</b-nav-item> 
				<b-nav-item href="/skin-care" text="Organic"   v-bind:class="{ active: (currentMenu == 'menu-3') }">Skin Care </b-nav-item> -->
				
				 <b-nav-item href="/women" text="Fashion" right v-on:mouseover="currentMenu = 'menu-6',currentMenuSub = 'fashion-women'"  v-bind:class="{ active: (currentMenu == 'menu-6') }">Women<div class="arrBox_h"> </div></b-nav-item>
				 
				 <b-nav-item href="/men" text="Fashion" right v-on:mouseover="currentMenu = 'menu-1',currentMenuSub = 'fashion-women'"  v-bind:class="{ active: (currentMenu == 'menu-1') }">Men<div class="arrBox_h"> </div></b-nav-item>
				 
				 
				 
				 
            <b-nav-item href="/cosmetics" text="Cosmetics" right v-on:mouseover="currentMenu = 'menu-2',currentMenuSub = 'makeup'" v-bind:class="{ active: (currentMenu == 'menu-2') }">Cosmetics <div class="arrBox_h"> </div></b-nav-item> 
            <b-nav-item href="/organic" text="Organic" right v-on:mouseover="currentMenu = 'menu-3'"  v-bind:class="{ active: (currentMenu == 'menu-3') }">Organic <div class="arrBox_h"> </div></b-nav-item>
            <b-nav-item href="/home-essentials" v-on:mouseover="currentMenu = 'menu-4',currentMenuSub = 'bedroom'"  v-bind:class="{ active: (currentMenu == 'menu-4') }">Home Essentials <div class="arrBox_h"> </div></b-nav-item>
            
            <!--<b-nav-item href="/indian-crafts" text="indian crafts" right v-on:mouseover="currentMenu = 'menu-5',currentMenuSub = 'handloom'"  v-bind:class="{ active: (currentMenu == 'menu-5') }">Indian Crafts <div class="arrBox_h"> </div></b-nav-item> -->
				
				<li  @mouseover="onLeave">
					<auto-complete></auto-complete>
					<!--<form @submit.prevent="changeQuery">
				   
					  
					  <b-input-group style="min-width:290px;border:0px;">
						<b-form-input placeholder="Search for products, brands etc."  :class="{ loading : loading === true }" v-model="query" style="border-radius: 25px 0px 0px 25px !important;border:0px;" ></b-form-input>
						<b-input-group-append>
						  
						  <b-button type="submit" variant="warning" style="border-radius: 0 25px 25px 0px;color: #fff;" ><i class="fa fa-search" aria-hidden="true"></i></b-button>
						</b-input-group-append>
					  </b-input-group>
					  
					</form>-->
					
					
					
					<!--ul class="search-result" v-if="result.length > 0">
						<li v-for="(re,index) in result" :key="index" :class="{ focus: index === focus }">
							<a :href="re.slug">{{ re.title }}</a>
						</li>
					</ul-->
				</li>
				
				
				<!-- Cart Leftpanel-->
				<b-nav-item v-if="$root.cart.quantity==0" class="shopping-basket mt-1 m-0 clickToCart" v-b-toggle.cartPanel  @mouseover="onLeave"  ><b-icon icon="cart3" aria-hidden="true" style="font-size: 20px;"></b-icon><span>{{$root.cart.quantity}}</span> <div class="titleIcons" >Cart</div></b-nav-item>
				<b-nav-item  v-else class="shopping-basket mt-1 m-0 clickToCart" v-b-toggle.cartPanel @mouseover="onLeave" ><b-icon icon="cart3" aria-hidden="true" style="font-size: 20px;"></b-icon><span>{{$root.cart.quantity}}</span><div class="titleIcons" >Cart</div></b-nav-item>
				<!-- ============ --> 

				 <b-nav-item v-if="$root.customer_info.user_id>0 && $root.customer_info.role !=3" :href="wishlistUrl" class="shopping-basket mt-1 m-0 clickToWishlist"  @mouseover="onLeave" ><b-icon icon="heart" aria-hidden="true" style="font-size: 20px;"></b-icon> <div class="titleIcons" >Wishlist</div> </b-nav-item>
					
				 <b-nav-item  v-if="$root.customer_info.role==3"  class="shopping-basket mt-1 m-0" v-b-toggle.cartShop @mouseover="onLeave"  ><b-icon class="py-0 " icon="bag" aria-hidden="true" ></b-icon> <i class="bi bi-bag"></i> <span>{{$root.share.shareitems.length}}</span>
				 <div class="titleIcons" >Shop</div>
				<!--<a href="javascript:void(0);" class="shopcart-icon" data-teamo="teamo-dropdown">Cart<span class="count">0</span></a> -->

				 </b-nav-item>

				
				 <b-nav-item v-if="$root.customer_info.user_id == 0" href="/login" class="m-0 shopping-basket mt-1 " @mouseover="onLeave" >
				  <b-icon class="py-0 " icon="person" aria-hidden="true" ></b-icon> <div class="titleIcons" >Login</div>
				 </b-nav-item>
				<b-nav-item-dropdown right class="header-customdd  m-0"  @mouseover="onLeave" v-else>
				  <template v-slot:button-content @mouseover="onLeave"> 
					<em style="font-size: 19px;" ><b-icon class="py-0 " icon="person" aria-hidden="true" @mouseover="onLeave" ></b-icon></em>
					<div class="titleIcons" style="position:absolute;text-transform: capitalize;">{{myShortName||'Hello'}}</div>
					<!--<em v-if="$session.get('customer_info')">{{$root.customer_info.custname}}</em> -->
				  </template>  
				   
					<!--<span class="mr-2">Hello{{$root.customer_info.role}} {{$root.customer_info.custname}}</span> -->
					<!--span class="mr-2">Hello {{$root.customer_info.custname}}</span -->
					<span v-if="$root.customer_info.role==4">
					<b-dropdown-item href="/customer/dashboard" class="mx-2">My Account</b-dropdown-item>
					<b-dropdown-item href="/customer/wallet">My Wallet</b-dropdown-item>
					<b-dropdown-item href="#" v-b-modal="'cp-modal'">Change Password</b-dropdown-item>
					<b-dropdown-item href="/faq" >FAQs</b-dropdown-item>
					<b-dropdown-item href="/survey" >Feedback Form</b-dropdown-item>
					<b-dropdown-item href="/videos" >Watch & Buy</b-dropdown-item>
					<b-dropdown-item href="/logout" class="ml-2" >Logout</b-dropdown-item>
				  </span>
				  <span v-if="$root.customer_info.role==3">
					<b-dropdown-item :href="'/'+$root.INFLUENCER+'/dashboard'" class="mx-2">My Account</b-dropdown-item>
					<b-dropdown-item :href="'/'+$root.INFLUENCER+'/my-shop'" class="mx-2">My Shop</b-dropdown-item>
					<b-dropdown-item :href="'/'+$root.INFLUENCER+'/wishlist'" class="mx-2">My Wishlist</b-dropdown-item>
					<b-dropdown-item href="#" v-b-modal="'cp-modal'">Change Password</b-dropdown-item>
					<b-dropdown-item href="/faq" >FAQs</b-dropdown-item>
					<b-dropdown-item href="/survey" >Feedback Form</b-dropdown-item>
					<b-dropdown-item href="/videos" >Watch & Buy</b-dropdown-item>
					<b-dropdown-item href="/logout" class="ml-2">Logout</b-dropdown-item>
				  </span>
				   <span v-if="$root.customer_info.role==2">
					<b-dropdown-item href="/seller/dashboard" class="mx-2">My Account</b-dropdown-item>
					<b-dropdown-item href="#" v-b-modal="'cp-modal'">Change Password</b-dropdown-item>
					<b-dropdown-item href="/faq" >FAQs</b-dropdown-item>
					<b-dropdown-item href="/survey" >Feedback Form</b-dropdown-item>
					<b-dropdown-item href="/seller/videos" >Upload Videos</b-dropdown-item>
					<b-dropdown-item href="/logout" class="ml-2" >Logout</b-dropdown-item>
				  </span>
				   <span v-if="$root.customer_info.role==1">
					<b-dropdown-item href="/admin/dashboard" class="mx-2">My Account</b-dropdown-item>
					<b-dropdown-item href="#" v-b-modal="'cp-modal'">Change Password</b-dropdown-item>
					<b-dropdown-item href="/faq" >FAQs</b-dropdown-item>
					<b-dropdown-item href="/survey" >Feedback Form</b-dropdown-item>
					<b-dropdown-item href="/videos" >Watch & Buy</b-dropdown-item>
					<b-dropdown-item href="/logout" class="ml-2" >Logout</b-dropdown-item> 
				  </span>
					<!-- @click="$root.logout()" -->
				</b-nav-item-dropdown>
			  </b-navbar-nav>
			</b-collapse>

		  </b-navbar>
		  	<div class="nav-content">
			<div class="dropdown" v-bind:class="{ active: (currentMenu == 'menu-1') }" @mouseleave="onLeave" >
				<div class="d-flex justify-content-center font-md ">
					<b-container style="width: 100%;position: absolute;">
						<div class="MegaDropdowntopWrapper">
						   <div class="MegaDropdown-ContentInnerC bgWhite" style="height: 376px;">
							  <div class="MegaDropdown-ContentHeading trendingLink"> <a href="/trending-products/men">#Trending </a> </div>
							  <div class="MegaDropdown-ContentHeading"> <a href="/men-top-wear">Top Wear</a> </div>
							  <div class="glamnfitstoreBox megaDropdown">
									<ul> 
										<li><a href="/men-t-shirts">T Shirts</a></li>
										<li><a href="/men-formal-shirts">Formal Shirts</a></li>
										<li><a href="/men-casual-shirts">Casual Shirts</a></li>
										<li><a href="/men-sweaters-sweatshirts">Sweaters & Sweatshirts</a></li>
										<li><a href="/men-jackets">Jackets</a></li>
										<li><a href="/men-suits">Suits</a></li>
									 </ul>
									
								</div>
								<div class="MegaDropdown-ContentHeading"> <a href="/men-accessories">Men Accessories</a></div>
							  <div class="glamnfitstoreBox megaDropdown">
								 <ul> 
									<li><a href="/bags-belts-wallets">Bags, Belts & Wallets</a></li>
									<li><a href="/men-jewellery">Jewellery</a></li>
									<li><a href="/men-watches">Watches</a></li>
									<li><a href="/men-sunglasses">Sunglasses</a></li>
								</ul>
							  </div>
							
						   </div>
						   <div class="MegaDropdown-ContentInnerC bgGrey" style="height: 376px;">
							  <div class="MegaDropdown-ContentHeading"> <a href="/men-bottom-wear">Bottom Wear</a> </div>
							  <div class="glamnfitstoreBox megaDropdown">
								<ul> 
									<li><a href="/men-jeans">Jeans</a></li>
									<li><a href="/men-formal-trousers">Formal Trousers</a></li>
									<li><a href="/men-casual-trousers">Casual Trousers</a></li>
									<li><a href="/men-shorts">Shorts</a></li>
								 </ul>
							  </div>
							    <div class="MegaDropdown-ContentHeading"> <a href="/men-footwear">Men Footwear</a></div>
							  <div class="glamnfitstoreBox megaDropdown">
								 <ul> 
									<li><a href="/men-sports-shoes">Sports Shoes</a></li>
									<li><a href="/men-formal-shoes">Formal Shoes</a></li>
									<li><a href="/men-casual-shoes">Casual Shoes</a></li>
									<li><a href="/men-sandals">Sandals</a></li>
									<li><a href="/men-kohlapuri">Kohlapuri</a></li>
								 </ul>
							  </div>
							
						   </div> 
						   <div class="MegaDropdown-ContentInnerC bgWhite" style="height: 376px;">
							  <div class="MegaDropdown-ContentHeading"> <a href="/men-indian-festival-wear">Indian & Festival Wear</a></div>
							  <div class="glamnfitstoreBox megaDropdown">
									<ul> 
									<li><a href="/men-kurtas-kurta-sets">Kurtas & Kurta Sets</a></li>
									<li><a href="/men-sherwanis">Sherwanis</a></li>
									<li><a href="/nehru-jackets">Nehru Jackets</a></li>
									<li><a href="/men-shawls-stoles">Shawls & Stoles</a></li>
									</ul>
								</div>
								<div class="MegaDropdown-ContentHeading"> <a href="/men-nightdress-innerwear">Nightdress & Innerwear</a></div>
								<div class="glamnfitstoreBox megaDropdown">
									<ul> 
										<li><a href="/boxers">Boxers</a></li>
										<li><a href="/briefs">Briefs</a></li>
										<li><a href="/vests">Vests</a></li>
										<li><a href="/men-sleepwear">Sleepwear</a></li>
									</ul>
								</div>
							
						   </div> 
						   <!-- <div class="MegaDropdown-ContentInner bgGrey">
							  <div class="MegaDropdown-ContentHeading"> <a href="/na	ils">Nightdress & Innerwear</a></div>
								<div class="glamnfitstoreBox megaDropdown">
									<ul> 
										<li><a href="/men/dresses">Boxers</a></li>
										<li><a href="/men/jumpsuits">Briefs</a></li>
										<li><a href="/men/shorts-skirts">Vests</a></li>
										<li><a href="/men/sweaters-sweatshirts">Sleepwear</a></li>
									</ul>
								</div>
							
						   </div> -->
						   <div class="MegaDropdown-ContentInnerC bgGrey" style="height: 376px;">
							  <div class="MegaDropdown-ContentHeading"> <a href="/men-sportswear">Sports Wear</a></div>
							  <div class="glamnfitstoreBox megaDropdown">
									<ul> 
									<li><a href="/men-sports-shoes">Sports Shoes</a></li>
									<li><a href="/men-sports-sandals">Sports Sandals</a></li>
									<li><a href="/men-active-t-shirts">Active T-Shirts</a></li>
									<li><a href="/men-tracksuits">Tracksuits</a></li>
									<li><a href="/men-jackets-sweatshirts">Jackets & Sweatshirts</a></li>
									</ul>
								</div>
							 <div class="MegaDropdown-ContentHeading"> <a href="/mens-grooming">Men's Grooming</a></div>
						   </div>  
						  
						   						
						</div>
					</b-container>
							 
						  </div> 
					</div>
			<div class="dropdown" v-bind:class="{ active: (currentMenu == 'menu-2') }" @mouseleave="onLeave">
				<div class="d-flex justify-content-center font-md ">
				<b-container style="width: 100%;position: absolute;">
					<div class="MegaDropdowntopWrapper">						
					   <div class="MegaDropdown-ContentInnerC bgWhite heightCos" >	
						<div class="MegaDropdown-ContentHeading trendingLink"> <a href="/trending-products/cosmetics">#Trending</a> </div>
						  <div class="MegaDropdown-ContentHeading"> <a href="/face">Face</a> </div>
						  <div class="glamnfitstoreBox megaDropdown">
							 <ul>
								<li><a href="/foundation">Foundation</a></li>
								<li><a href="/compact-powder">Compact Powder</a></li>
								<li><a href="/concealer">Concealer</a></li>
								<li><a href="/blushes">Blushes</a></li>
								<li><a href="/bronzers">Bronzers</a></li>
								<li><a href="/highlighters-illuminators">Highlighters & Illuminators</a></li>
								<li><a href="/primers">Primers</a></li>
								<li><a href="/sindoors">Sindoors</a></li>
								</ul>
							</div>
							<div class="MegaDropdown-ContentHeading"> <a href="/hair-care">Hair Care</a></div>
						  <div class="glamnfitstoreBox megaDropdown">				
							<ul>
								<li><a href="/shampoo-conditioner"> Shampoo & Conditioner</a></li>
								<li><a href="/hair-styling-and-treatment">Hair Styling and Treatment</a></li>
								<li><a href="/tools-and-accessories">Tools and Accessories</a></li>
							</ul>
						 </div>
						
					   </div>
					   <div class="MegaDropdown-ContentInnerC bgGrey heightCos">
						
						  <div class="MegaDropdown-ContentHeading"> <a href="/eyes">Eyes</a> </div>
						  <div class="glamnfitstoreBox megaDropdown">
							 <ul>
							<li><a href="/kajal-kohls">Kajal & Kohls</a></li>
							<li><a href="/eyeliners">Eyeliners</a></li>
							<li><a href="/mascaras">Mascaras</a></li>
							<li><a href="/eyeshadow">Eyeshadow</a></li>
							<li><a href="/eye-concealer">Eye Concealer</a></li>
							<li><a href="/eyebrow-colors">Eyebrow Colors</a></li>
							</ul></div>
							 <div class="MegaDropdown-ContentHeading"> <a href="/fragrances">Fragrances</a></div>
						  <div class="glamnfitstoreBox megaDropdown">				
							<ul>
								<li><a href="/men-fragrances">Men's</a></li>
								<li><a href="/women-fragrances">Women's</a></li>
								<li><a href="/unisex-fragrances">Unisex</a></li>
							</ul>
						 </div>
						
					   </div> 
					   <div class="MegaDropdown-ContentInnerC bgWhite heightCos">
					   
						  <div class="MegaDropdown-ContentHeading"> <a href="/lips">Lips</a></div>
						  <div class="glamnfitstoreBox megaDropdown">
							 <ul>
							<li><a href="/Lipstick">Lipstick</a></li>
							<li><a href="/lip-glosses">Lip Glosses</a></li>
							<li><a href="/lip-liners">Lip Liners</a></li>
							</ul>
							</div>
							<div class="MegaDropdown-ContentHeading"> <a href="/personal-care">Personal Care</a></div>
						  <div class="glamnfitstoreBox megaDropdown">				
							<ul> 
								
								<li><a href="/bath-body-care">Bath & Body Care</a></li>
								<li><a href="/feminine-hygiene">Feminine Hygiene</a></li>
								<!--<li><a href="/mens-grooming">Men's Grooming</a></li>-->
							 </ul>
						 </div>
						
					   </div> 
					   <div class="MegaDropdown-ContentInnerC bgGrey heightCos">					  
						  <div class="MegaDropdown-ContentHeading"> <a href="/nails">Nails</a></div>
						  <div class="glamnfitstoreBox megaDropdown">
							 <ul>
							<li><a href="/nail-gel">Nail Gel</a></li>
							<li><a href="/nail-polish">Nail Polish</a></li>
							<li><a href="/manicure">Manicure</a></li>
							</ul>
							</div>
							 <div class="MegaDropdown-ContentHeading"> <a href="/skin-care">Skin Care</a></div>
						  <div class="glamnfitstoreBox megaDropdown">
							<ul> 
								<li><a href="/cleansers-toners">Cleansers & Toners</a></li>
								<li><a href="/moisturizers">Moisturizers</a></li>
								<li><a href="/eye-care">Eye Care</a></li>
								<li><a href="/sun-care">Sun Care</a></li>
								<li><a href="/masks">Masks</a></li>
							 </ul>
						 </div>
						
					   </div> 
					   <!--<div class="MegaDropdown-ContentInner bgWhite">
						  <div class="MegaDropdown-ContentHeading"> <a href="/skin-care">Skin Care</a></div>
						  <div class="glamnfitstoreBox megaDropdown">
							<ul> 
								<li><a href="/cleansers-toners">Cleansers & Toners</a></li>
								<li><a href="/moisturizers">Moisturizers</a></li>
								<li><a href="/eye-care">Eye Care</a></li>
								<li><a href="/sun-care">Sun Care</a></li>
								<li><a href="/masks">Masks</a></li>
							 </ul>
						 </div>
						
					   </div> --> 
					   
					   
 
														
					</div>		
				</b-container>

				</div> 
			</div>
			<div class="dropdown" v-bind:class="{ active: (currentMenu == 'menu-3') }" @mouseleave="onLeave">
				<div class="d-flex justify-content-center font-md ">
					<b-container style="width: 100%;position: absolute;">
						<div class="MegaDropdownHeading popUpsHeading1">
							 <a href="/trending-products/organic" class="MegaDropdownHeadingbox meganewdiv" v-on:mouseover="currentMenuSub = 'trending-products'" v-bind:class="{ current_active: (currentMenuSub == 'trending-products') }"> #Trending </a> 
							 <a href="/skin-nutrition" class="MegaDropdownHeadingbox meganewdiv" v-on:mouseover="currentMenuSub = 'skin-nutrition'" v-bind:class="{ current_active: (currentMenuSub == 'skin-nutrition') }"> Skin Nutrition </a>
							 <a  href="/hair-nutrition"  class="MegaDropdownHeadingbox meganewdiv " v-on:mouseover="currentMenuSub = 'hair-nutrition'"  v-bind:class="{ current_active: (currentMenuSub == 'hair-nutrition') }">Hair Nutrition</a>
							 <a  href="/kids-nutrition"  class="MegaDropdownHeadingbox meganewdiv " v-on:mouseover="currentMenuSub = 'kids-nutrition'"  v-bind:class="{ current_active: (currentMenuSub == 'kids-nutrition') }">Kid's Nutrition</a>
							 <a  href="/ayurvedic-immunity-booster" class="MegaDropdownHeadingbox meganewdiv " v-on:mouseover="currentMenuSub = 'ayurvedic-immunity-booster'"  v-bind:class="{ current_active: (currentMenuSub == 'ayurvedic-immunity-booster') }">Ayurvedic Immunity Booster</a>
						</div>
					</b-container>
				</div>
			</div>
			<div class="dropdown" v-bind:class="{ active: (currentMenu == 'menu-4') }" @mouseleave="onLeave">
				<div class="d-flex justify-content-center font-md ">
					<b-container style="width: 100%;position: absolute;">
						<div class="MegaDropdowntopWrapper">
							<div class="MegaDropdown-ContentInner bgWhite">
								  <div class="MegaDropdown-ContentHeading trendingLink"> <a href="/trending-products/home-essentials">#Trending</a> </div>
								  <div class="MegaDropdown-ContentHeading"> <a href="/home-decor">Home Decor</a> </div>
								  <div class="glamnfitstoreBox megaDropdown">
										 <ul>
											<li><a href="/bedding">Bedding</a></li>
											<li><a href="/bedroom-furnishings"> Bedroom Furnishings</a></li>
											<!--<li><a href="/bedroomfurniture">	BedroomFurniture</a></li> -->
										</ul>
									</div>
							</div>
						  <div class="MegaDropdown-ContentInner bgGrey" style="height: 285px;">
							  <div class="MegaDropdown-ContentHeading"> <a href="/arts-and-crafts">Arts and Crafts</a> </div>
							  <div class="glamnfitstoreBox megaDropdown">
								 <ul>
								<li><a href="/handicrafts">Handicrafts</a></li>
								<li><a href="/handloom-linen">	Handloom Linen</a></li>
								<li><a href="/decoratives">Decoratives</a></li> 
								</ul>
							  </div>
						   </div>
						    <div class="MegaDropdown-ContentInner bgWhite">
							  <div class="MegaDropdown-ContentHeading"> <a href="/books">Books</a> </div>
							  <div class="glamnfitstoreBox megaDropdown">
								 <ul>
								<li><a href="/lifestyle-hobby">Lifestyle & Hobby</a></li>
								<li><a href="/healthy-living">Healthy Living</a></li>
								<li><a href="/literature">Literature</a></li> 
								<li><a href="/school-books">School Books</a></li> 
								<li><a href="/self-help">Self-Help</a></li> 
								<li><a href="/children">Children</a></li> 
								<li><a href="/fiction-books">Fiction Books</a></li> 
								<li><a href="/economics-business">Economics & Business</a></li> 
								</ul>
							  </div>
						   </div>
						   <div class="MegaDropdown-ContentInner bgGrey" style="height: 285px;">
							  <div class="MegaDropdown-ContentHeading"> <a href="/kitchen-dining">Kitchen & Dining</a></div>
							  <div class="glamnfitstoreBox megaDropdown">
									<ul>
									<!--
									
									<li><a href="/utility">Utility</a></li> -->
									<li><a href="/Ready-To-Eat-Cook">Ready to Eat & Cook</a></li>
									<li><a href="/cookware">Cookware</a></li>
									<li><a href="/bakeware">Bakeware </a></li>
									</ul>
								</div> 
								
								
								
						   </div> 
						   <div class="MegaDropdown-ContentInner bgWhite" style="height: 285px;">
							 <div class="MegaDropdown-ContentHeading"> <a href="/pet-care">Pet Care</a></div>
							  <div class="glamnfitstoreBox megaDropdown">
									<ul>
									<li><a href="/food-treats">Food & Treats</a></li>
									<li><a href="/accessories-toys">Accessories & Toys</a></li> 
									</ul>
								</div>
								
						   </div> 
						   
														
					</div>
				</b-container>
			</div> 
		</div>
			<div class="dropdown" v-bind:class="{ active: (currentMenu == 'menu-5') }" @mouseleave="onLeave">
				<div class="d-flex justify-content-center font-md ">
					<b-container style="width: 100%;position: absolute;">
						<div class="MegaDropdowntopWrapper">
							<!--<div class="MegaDropdown-ContentInnerC bgWhite">
							  <div class="MegaDropdown-ContentHeading"> <a href="/handloom">Handloom</a> </div>
							  <div class="glamnfitstoreBox megaDropdown">
								 <ul>
									<li><a href="/handloom-sarees">Sarees</a></li>
									<li><a href="/suites">Suites</a></li>
									<li><a href="/shawls-and-stoles">Shawls & Stoles</a></li>
									<li><a href="/handloom-fabrics">Fabrics</a></li>
								</ul>
							 </div>
							</div> -->
							<div class="MegaDropdown-ContentInnerC bgWhite">
								<div class="MegaDropdown-ContentHeading"> <a href="/decor">Decor</a> </div>
								<div class="glamnfitstoreBox megaDropdown">
									<ul>
										<li><a href="/decor-living-room">Living Room</a></li>
										<li><a href="/decor-bedroom">Bedroom</a></li>
										<li><a href="/decor-bathroom">Bathroom</a></li>
									</ul> 
								</div>
							</div>
							<!--<div class="MegaDropdown-ContentInnerC bgGrey">
								<div class="MegaDropdown-ContentHeading"> <a href="/ethnic-wear">Ethnic Wear</a> </div>
								<div class="glamnfitstoreBox megaDropdown">
									<ul>
									<li><a href="/ethnic-wear-sarees">Sarees</a></li>
									<li><a href="/ethnic-wear-suites">Suites</a></li>
									<li><a href="/ethnic-wear-shawls-and-stoles">Shawls & Stoles</a></li>
									<li><a href="/ethnic-wear-fabrics">Fabrics</a></li>
									</ul>
								</div>
							</div>-->
							<div class="MegaDropdown-ContentInnerC bgGrey">
								<div class="MegaDropdown-ContentHeading"> <a href="/indian-crafts-accessories">Accessories</a> </div>
								<div class="glamnfitstoreBox megaDropdown">
									<ul>
									<li><a href="/ethnic-wear-sarees">Sarees</a></li>
									<li><a href="/ethnic-wear-suites">Suites</a></li>
									<li><a href="/ethnic-wear-shawls-and-stoles">Shawls & Stoles</a></li>
									<li><a href="/ethnic-wear-fabrics">Fabrics</a></li>
									</ul>
								</div>
							</div>			
						</div>

					</b-container>
				</div> 

			
			</div>
			<div class="dropdown" v-bind:class="{ active: (currentMenu == 'menu-6') }" @mouseleave="onLeave">
				<div class="d-flex justify-content-center font-md ">
					<b-container style="width: 100%;position: absolute;">
						<div class="MegaDropdowntopWrapper">
						   <div class="MegaDropdown-ContentInner bgWhite" style="height: 319px;">
							  <div class="MegaDropdown-ContentHeading trendingLink"> <a href="/trending-products/women">#Trending</a> </div>
							  <div class="MegaDropdown-ContentHeading"> <a href="/women-indian-wear">Indian Wear</a> </div>
							  <div class="glamnfitstoreBox megaDropdown">
									<ul> 
										<li><a href="/kurtas-suits">Kurtas & Suits</a></li>
										<li><a href="/kurtis-tops">Kurtis & Tops</a></li>
										<li><a href="/leggings-salwars">Leggings & Salwars</a></li>
										<li><a href="/skirts-palazzos">Skirts & Palazzos</a></li>
										<li><a href="/sarees">Sarees</a></li>
										<li><a href="/women-dress-materials">Dress Materials</a></li>
										<li><a href="/lehenga-choli">Lehenga Choli</a></li>
										<li><a href="/dupatta-shawls">Dupatta & Shawls</a></li>
										<li><a href="/women-jackets">Jackets</a></li>
										<li><a href="/women-ethnic-wear">Ethnic Wear</a></li>
									 </ul>
									
								</div>
							
						   </div>
						   <div class="MegaDropdown-ContentInner bgGrey" style="height: 319px;">
							  <div class="MegaDropdown-ContentHeading"> <a href="/women-western-wear">Western Wear</a> </div>
							  <div class="glamnfitstoreBox megaDropdown">
								<ul> 
									<li><a href="/gowns-dresses">Gowns & Dresses</a></li>
									<li><a href="/jumpsuits">Jumpsuits</a></li>
									<li><a href="/shorts-skirts">Shorts & Skirts</a></li>
									<li><a href="/women-sweaters-sweatshirts">Sweaters & Sweatshirts</a></li>
									<li><a href="/tops-t-shirts">Tops & T-Shirts</a></li>
									<li><a href="/women-jeans-pants">Jeans & Pants</a></li>
								 </ul>
							  </div>
							
						   </div> 
						   <div class="MegaDropdown-ContentInner bgWhite" style="height: 319px;">
							  <div class="MegaDropdown-ContentHeading"> <a href="/women-nightdress-lingerie">Nightdress & Lingerie</a></div>
							  <div class="glamnfitstoreBox megaDropdown">
									<ul>
										<li><a href="/women-sleepwear">Sleepwear</a></li>
										<li><a href="/women-loungewear">Loungewear</a></li>
										<li><a href="/lingerie">Lingerie</a></li>
										<li><a href="/women-briefs">Briefs</a></li>
									</ul>
								</div>
								
						   </div> 
						   <div class="MegaDropdown-ContentInner bgGrey" style="height: 319px;">
							  <div class="MegaDropdown-ContentHeading"> <a href="/women-sportswear">Sports Wear</a></div>
							  <div class="glamnfitstoreBox megaDropdown">
								<ul>
									<li><a href="/women-sports-wear-clothing">Clothing</a></li>
									<li><a href="/women-sports-footware">Footware</a></li>
									<li><a href="/women-sports-accessories">Sports Accessories</a></li>
								</ul>
								</div>
								<div class="MegaDropdown-ContentHeading"> <a href="/women-footwear">Women Footwear</a></div>
							  <div class="glamnfitstoreBox megaDropdown">
							<ul> 

							<li><a href="/women-shoes">Shoes</a></li>
							<li><a href="/women-sandals">Sandals</a></li>
							<li><a href="/women-sports-shoes">Sports Shoes</a></li>
							<li><a href="/women-kohlapuri">Kohlapuri</a></li>
							</ul>
								</div>
							
						   </div> 
						   <div class="MegaDropdown-ContentInner " style="height: 319px;">
							  <div class="MegaDropdown-ContentHeading"> <a href="/women-accessories">Women Accessories</a></div>
							  <div class="glamnfitstoreBox megaDropdown">
									<ul> 
										<li><a href="/handbags-clutches">Handbags & Clutches</a></li>
										<li><a href="/women-jewellery">Jewellery</a></li>
										<li><a href="/women-watches">Watches</a></li>
										<li><a href="/women-sunglasses">Sunglasses</a></li>
										<li><a href="/women-hair">Hair</a></li>
									 </ul>
								</div>
						   </div> 						
						</div>
					</b-container>

					  </div> 

				</div>

		</div>


		  <b-modal id="cp-modal" title="Change Password" ok-only @hidden="resetSelectedItem" >
			<form ref="form">
			
			<b-form-group :state="current_passwordState" label="Current Password" label-cols="4" label-size="sm" label-align-sm="right" label-for="cpc-input" invalid-feedback="Please enter current password!">
			<b-form-input type="password" id="cpc-input" v-model="current_password" v-on:change="current_passwordState = null" size="sm"></b-form-input>
			</b-form-group>
		
			<b-form-group :state="new_passwordState" label="New Password" label-cols="4" label-size="sm" label-align-sm="right" label-for="cpn-input" invalid-feedback="Password should be greater than 4 digits">
				<b-form-input type="password" id="cpn-input" v-model="new_password" v-on:change="new_passwordState = null" size="sm"></b-form-input>
			</b-form-group>
			
			
			  <!--<b-form-group label="Current Password" label-cols="4" label-size="sm" label-align-sm="right" invalid-feedback="Email is required">
				<b-form-input v-model="current_password" type="password"  required></b-form-input>
			  </b-form-group>
			  <b-form-group label="New Password" label-cols="4" label-size="sm" label-align-sm="right">
				<b-form-input v-model="new_password" type="password" :state="passwordState" required></b-form-input>
				<b-form-invalid-feedback id="input-live-feedback">
				  Enter at least 4 letters
				</b-form-invalid-feedback>
			  </b-form-group> -->
			</form>
			<template v-slot:modal-footer="{ ok, close }">
			  <b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
			  <b-button size="sm" variant="success"  @click="modalSubmit">Update</b-button>
			</template>
		  </b-modal>
		</b-container>
		</div>
	</template>
    <login-modal></login-modal>
    <forgetpassword-modal></forgetpassword-modal>
    <register-modal></register-modal>
    <!--<sidemenu></sidemenu>-->
	<cart-panel :cartItems="$root.cart.items" :cartTotalqty="$root.cart.quantity" :cartData="$root.cart" :walletData="$root.customer_info['wallet']" ></cart-panel>


	<cart-shop :cartItems="$root.share.shareitems"  :cartData="$root.share.shareitems" :cartTotalqty="$root.share.shareitems.length"></cart-shop>
	
	<!--<menu-panel :brandallList="brandallList"></menu-panel> -->

	<menu-web :brandallList="brandallList"></menu-web>
	
	<sharelik-popup :selectedItemcart="$root.share.linkItems"  :selectedLink="$root.share.link" iamin="sharelinkcart"></sharelik-popup>
	
	<sharemessage-popup></sharemessage-popup>
	<!--<promotion-popup></promotion-popup> -->
	<!--<diwali-popup></diwali-popup> -->
	<survey-popup></survey-popup>
	<surveyseller-popup></surveyseller-popup>
	
  </div>
</template>

<script>
import LoginModal from "@/components/login.vue";
import ForgetPasswordModal from "@/components/forget-password.vue";
import RegisterModal from "@/components/register.vue";
 /* import MegaMenu from '@/components/MegaMenu.vue' */
/*import Sidemenu from "@/components/sidemenu.vue";*/
import CartPanel from "@/components/cartPanel.vue";
import CartShop from "@/components/cartShop.vue";
import SharelinkPopup from "@/components/sharelink-popup.vue";
import SharemessagePopup from "@/components/sharemessage-popup.vue";
import MenuWeb from "@/components/menuWeb.vue";
//import MenuPanel from "@/components/menuPanel.vue";
//import Promotionpopup from "@/components/promotion-popup.vue";
import Surveypopup from "@/components/survey-popup.vue";
import Surveysellerpopup from "@/components/surveyseller-popup.vue";
//import Diwalipopup from "@/components/diwali-popup.vue";
import Autocomplete from "@/components/auto-complete.vue";
//import Offerflase from "@/components/offerflase.vue";
import Topbar from "@/components/home/Topbar.vue";

const OFFSETMenu = 60;
export default {
  //name: 'HelloWorld',
  name: 'Alluraa',
  components: {
    "login-modal": LoginModal,
    "forgetpassword-modal": ForgetPasswordModal,
    "register-modal": RegisterModal,
    /* MegaMenu, */
    /*"sidemenu": Sidemenu*/
	"cart-panel": CartPanel,
	"cart-shop": CartShop,
	 "sharelik-popup": SharelinkPopup,
	 "sharemessage-popup": SharemessagePopup,
	 //"menu-panel": MenuPanel,
	 "menu-web": MenuWeb,
	 //"promotion-popup": Promotionpopup,
	 "survey-popup": Surveypopup,
	 "surveyseller-popup": Surveysellerpopup,
	 //"diwali-popup": Diwalipopup,
	 "auto-complete": Autocomplete,
	 //"offer_flase": Offerflase,
	 "topbar": Topbar,
	},
  props: {
    msg: String
  },
  computed: {
    passwordState() {
      return this.new_password.length > 3 ? true : false
    }
  },
  watch:{
   /* headerCategories:function(){
     // console.log("----watch--");
    }*/
  },
  created() {

	/* window.addEventListener('beforeunload', function (e) {
			console.log(e.type+"event.type");
			//console.log('window.event'+JSON.stringify(window.event));
			console.log(performance.navigation.type,"performance.navigation.type");
			console.log(e.keyCode,"e.keyCode");
			var confirmClose = confirm('Close?');
			
			console.log('confirmClose'+confirmClose);
			console.log('asdasd'+e.which);
			e.preventDefault();
			e.returnValue = 'test';
			this.$root.$emit('bv::show::modal', 'surveypopup');
		}); */
	  

    },
  beforeMount(){
      var self = this;
       /* self.axios.post(self.$root.WEBURL+'header-category', {
              //accesskey: self.$root.customer_info.access_key,
          }).then(function (response) {
            //console.log(response);
              if(response.data.error == 0 || response.data.error == '0'){
                //console.log(response.data);
                  self.headerCategories = response.data.result.categories;
              }else if(response.data.error == 9){
                //self.$root.forceLogout(response.data.message);
              }
          }).catch(function (error) {
              alert(error);
          });
		  */
		  self.axios.post(self.$root.WEBURL+'header-brands', {
              //accesskey: self.$root.customer_info.access_key,
          }).then(function (response) {
            //console.log(response);
              if(response.data.error == 0 || response.data.error == '0'){
                //console.log(response.data);
                  self.brandsList = response.data.result.brandlist;
                  self.brandallList = response.data.result.brandalllist;
              }else if(response.data.error == 9){
                //self.$root.forceLogout(response.data.message);
              }
          }).catch(function (error) {
              alert(error);
          });
		  
		  
		 
		  
		 
		  
    //console.log(window.location.pathname)
  },
  mounted(){
		let recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-J5D103H4N0');
      document.head.appendChild(recaptchaScript);
	  
	  var dataLayer =[];
	  dataLayer.push({
					  'event': 'ecommerce',
					  'ecommerce': {
						'detail': {
						  'actionField': {'list': 'Apparel Gallery'},    // 'detail' actions have an optional list property.
						  'products': [{
							'name': 'Triblend Android T-Shirt',         // Name or ID is required.
							'id': '12345',
							'price': '15.25',
							'brand': 'Google',
							'category': 'Apparel',
							'variant': 'Gray'
						   }]
						 }
					   }
					});
	  let recaptchaScript2 = document.createElement('script');
      recaptchaScript2.innerHTML = dataLayer;
      document.head.appendChild(recaptchaScript2);
	  
       
		
		let s1 = document.createElement('script');
        s1.setAttribute('src', 'https://www.alluraa.com/js/js_main.js');
        document.head.appendChild(s1);
		
		var roleIdmy =this.$root.customer_info.role;
		if(roleIdmy == 1){
		this.wishlistUrl = '/admin/wishlist';
		}else if(roleIdmy == 2){
		this.wishlistUrl = '/seller/wishlist';
		}else if(roleIdmy == 3){
		this.wishlistUrl = '/'+this.$root.INFLUENCER+'/wishlist';
		}else if(roleIdmy == 4){
		this.wishlistUrl = '/customer/wishlist';
		}else{
		this.wishlistUrl = '/login';
		}
		
		
		if(roleIdmy>0){
			var str= this.$root.customer_info.username;
			/*var matches 	= str.match(/\b(\w)/g);
			var sname  		= matches.join(''); 
			this.myShortName= sname;*/
			const myArray = str.split(" ");
			this.myShortName= myArray[0];
			
			
		}
		
		 
		
		
		/* window.onbeforeunload = function(){
			alert("Are you sure you want to close the window?");
		}
		
	 window.addEventListener('beforeunload', function (e) {
			console.log(e.type+"event.type");
			//console.log('window.event'+JSON.stringify(window.event));
			console.log(performance.navigation.type,"performance.navigation.type");
			console.log(e.keyCode,"e.keyCode");
			
			console.log('asdasd'+e.which);
			e.preventDefault();
			e.returnValue = ' test';
		}); */
			/*
		window.addEventListener('beforeunload', function (e) {
		
			console.log('window.event'+window.event);
			/*var confirmationMessage = '\o/';
			 (e || window.event).returnValue = confirmationMessage;
			 return confirmationMessage; 
			 console.log('confirmationMessage:'+confirmationMessage);
		});*/
		
		
		
		/* --------promotion popup-----------*/
		/* var roleIdmy =this.$root.customer_info.role;
		if(roleIdmy==3){			
			if(this.$session.get('remindmelater')!=1){
				this.$root.$emit('bv::show::modal', 'promotionpopup');
				
			}
		} */
		var routeSurveyName = this.$route.name;
		console.log(routeSurveyName);
		if(routeSurveyName=='survey'){
			this.$root.$emit('bv::show::modal', 'surveypopup');
		}
		
		if(routeSurveyName=='surveyseller'){
			this.$root.$emit('bv::show::modal', 'surveysellerpopup');
		}
		/* ************************************* */
		 this.lastScrollPosition = window.pageYOffset;
		window.addEventListener('scroll', this.onScrollheadre);
		
	},
  data() {
    return{
	  tabIndex: 0,
      headerCategories:[],
      brandsList:[],
      brandallList:[],
      query:'',
      result:[],
      searchRequest:null,
      loading:false,
      focus:0,
      currentMenu: '',
	  currentMenuSub:'',
      selectedMenu: '',
      current_password: '', 
      new_password: '', 
	  current_passwordState: null, 
      new_passwordState:null, 
	  
      passwordUrl: this.$root.WEBAPI+'webapi/passwordchage',
      menuOpen: false,
	  thumbnailProps:'',
	  wishlistUrl:'/login',
	  myShortName:'Hello',
	  lastScrollPosition:0,
	  showSmallLogo: true,
    }
  },
  methods:{
   linkClass(idx) {
        if (this.tabIndex === idx) {
          return ['bg-primary', 'text-light']
        } else {
          return ['bg-light', 'text-info']
        }
	},
	onOver() {
        this.$refs.dropdown.visible = true;
      },
      onLeave() {
        //this.$refs.dropdown.visible = false;
		 this.currentMenu=''
      },
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    },
    
    /*changeQuery(e) {
        var self = this;
        this.result = [];
        if(e.keyCode == 40){
            (this.result.length-1 > this.focus) && this.focus++;
        }else if(e.keyCode == 38){
            this.focus > 0 && this.focus--;
        }else if(e.keyCode == 13){
            this.selectItem(this.focus);
        }else{
            this.loading = true;
            if (this.searchRequest) {
                this.searchRequest.cancel('Cancel previous request');
            }
            const CancelToken = self.axios.CancelToken;
            self.searchRequest = CancelToken.source();
            self.axios.get(this.$root.WEBURL+'search/?q=' + this.query,{cancelToken: this.searchRequest.token })
            .then(res => {
                this.result = res.data.result.products;
                this.loading = false;
            });
        }

    },*/
    changeQuery() {
      window.location = '/search/?q=' + this.query;
      //this.name = submitEvent.target.elements.name.value
    },
    selectItem(index){
        window.location.href = this.result[index].slug;
    },
    resetSelectedItem(){
      this.current_password = '';
      this.new_password = '';
    },
    modalSubmit(){
	var valid = true;

			if(this.current_password=='') {
				this.current_passwordState= false;
				valid = false;
			}else this.current_passwordState = true;
			
		if(this.new_password.length<4) {
				this.new_passwordState = false;
				valid = false;
			}else this.new_passwordState = true;
			
			if(valid){
	
	
			  var self = this;
			  //self.loading = true;
			  //bvModalEvt.preventDefault();
			  var submitUrl = self.passwordUrl;

			  var o = {'cp': this.current_password, 'np': this.new_password};

			  self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: o
			  })
			  .then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
				  self.$bvModal.hide('my-modal');
				  self.$bvToast.toast(response.data.message, {
					title: 'Status',
					toaster: 'b-toaster-bottom-right',
					autoHideDelay: 5000,
					variant: 'success',
					solid: true,
					appendToast: true
				  });
				  self.$bvModal.hide('cp-modal');
				}else{
					self.$bvModal.hide('my-modal');
				  self.$bvToast.toast(response.data.message, {
					title: 'Status',
					toaster: 'b-toaster-bottom-right',
					autoHideDelay: 5000,
					variant: 'warning',
					solid: true,
					appendToast: true
				  });
				
				}
				
			  })
			  .catch(function (error) {
				alert(error);
			  });
		}
    },
	 onScrollheadre () {
      if (window.pageYOffset < 0) {
        return
      }
      if (Math.abs(window.pageYOffset - this.lastScrollPosition) < OFFSETMenu) {
        return
      }
      this.showSmallLogo = window.pageYOffset < this.lastScrollPosition
      this.lastScrollPosition = window.pageYOffset
    }
  }
}
</script>

<!-- add "scoped" attribute to limit CSS to this component only -->
<!-- style scoped lang="scss"> -->
<style scoped lang="scss">
.header{
  position: fixed;
  top:0px;
  width: 100%;
  z-index: 10;
  .collapsed{
      max-width: 100%;
  }
  
}
.myclassZ{
 z-index: 9999999;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.search-result{
        position: absolute;
        background-color: #fff;
        z-index: 999;
        width: 200px;
        list-style: none;
    }
    .focus a{
        color:#EF1764;
    }

.header-customdd .dropdown-menu{
  left: unset;
}
.header-customdd .dropdown-menu li a{
 color: #000 !important;
 text-align: left;
}

.header-customdd .dropdown-menu li.nav-item:hover a {
    color: #fff;
    text-align: left;
}


.flaticon-user:before {
    content: "\f12c";
}
.userheader a{
font-size: 19px !important;
}


.popUpsHeading1 {
    position: relative;
    z-index: 10002 !important;
}
.popUpsHeading1 a:hover {
      text-decoration: none;
}
.MegaDropdownHeading {
    margin: 0 auto;
    text-align: center;
    background: #fff;
    height: 38px;
    line-height: 38px;
    box-shadow: 0 1px 1px 0 rgb(0 0 0 / 10%);
    -moz-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: 0 1px 1px 0 rgb(0 0 0 / 10%);
    position: relative;
}

.MegaDropdownHeading a::before{
background-color: unset;
}

.header-menu  ul li a:hover {
    cursor: pointer;
}
.MegaDropdownHeading .meganewdiv {
    /*width: 185px !important; */	
	width: auto;
    display: inline-flex;
    /* padding: 0px 39px 0 0px;*/
	margin: 0 28px 0px 0px;
}

.MegaDropdownHeading .current_active {
    font-weight: 600;
    border-bottom: 3px solid #fc2779;
    /* color: #fc2779;*/
}
.popUps-Content{
display:none;
}
.current_active_tab {
    display:block !important;
}
.popUpsContentBox {
   /* height: 466px; */
	 height: auto;
    position: relative;
    z-index: 7;
    box-shadow: 0px -1px 1px 0 rgb(0 0 0 / 10%);
}

/* .popUpsContentBox {
    height: 366px !important;
} */
.bgWhite {
    background-color: #fff;
}
.MegaDropdown-ContentInner {
    width: 20%;
    min-height: 273px;
    height: 100%;
    float: left;
    padding: 12px;
    text-align: left;
	margin-top:0%;
}
.MegaDropdown-ContentInnerC {
    width: 25%;
    min-height: 273px;
    height: 100%;
    float: left;
    padding: 12px;
    text-align: left;
	margin-top:0%;
}
.MegaDropdown-ContentInnerH {
    width: 25%;
    min-height: auto;
    height: 100%;
    float: left;
    padding: 12px;
    text-align: left;
	margin-top:0%;
}
.MegaDropdown-ContentInnerSingleline {
   
    height: auto;
    float: left;
    padding: 12px;
    text-align: left;
	margin-top:2%;
}
.MegaDropdown-ContentInnerSingleline ul li {
width:auto;
float:left;
margin:0 20px;
}
.MegaDropdown-ContentInnerSingleline ul > li a {
	color: rgba(3, 2, 26, 0.5);
}

.MegaDropdown-ContentInnerSinglelinebrand {
   
    height: auto;
    float: left;
    padding: 12px;
    text-align: left;
	margin-top:2%;
	height:419px
}
.MegaDropdown-ContentInnerSinglelinebrand ul li {
width:auto;
float:left;
margin:5px 14px;
}
.MegaDropdown-ContentInnerSinglelinebrand ul > li a {
	color: rgba(3, 2, 26, 0.5);
}
.bgGrey {
    background-color: #f7f7f7;
}
.MegaDropdown-ContentHeading {
    height: 18px;
    line-height: 18px;
    font-family: 'SourceSansPro-Semibold', sans-serif;
    font-weight: 600;
    font-size: 14px;
    text-transform: uppercase;
}

.megaDropdown ul li {
    position: relative;
	width:100%;
}
.megaDropdown ul > li a { 
    font-size: 14px;
    line-height: 18px;
    margin: 2% auto;
    display: block;
    color: rgba(3, 2, 26, 0.5);
    font-family: 'SourceSansPro-Regular', sans-serif;
    font-weight: 400;
    text-transform: capitalize;
}

.megaDropdownbrand ul li {
    position: relative;
	width:100%;
}
.megaDropdownbrand ul > span >li a { 
    font-size: 14px;
    line-height: 18px;
    margin:2px;
    display: block;
    color: rgba(3, 2, 26, 0.5);
    font-family: 'SourceSansPro-Regular', sans-serif;
    font-weight: 400;
    text-transform: capitalize;
}

.nav-content .dropdown a{
text-align:left !important;
}
.nav-content .dropdown a::before{
    background-color: unset;
}
.MegaDropdowntopWrapper{
position: absolute;
    width: 100%;
	background-color:#fff;
	box-shadow: 0 1px 1px 0 rgb(0 0 0 / 10%);
	border:1px solid rgb(0 0 0 / 10%);
}



.textColor{color: rgba(3, 2, 26, 0.5);}
.brandImage img{height:86px !important;
max-height: 120px;}

.shopcart-icon:before {
    content: "\f12e";
    font-family: Flaticon;
    font-size: 26px;
    font-weight: normal;
    position: relative;
    top: -5px;
}

.margingBaner{
margin-left: 8%;
}
.header .header-menu li.nav-item:hover .arrBox_h{
	visibility: visible;
}

.header .header-menu li.active .arrBox_h{
	visibility: visible;
}


.arrBox_h {
    width: 15px;
    /* height: 14px;
    position: relative;*/
    margin: 0 auto;
    bottom: 22px;
    z-index: 1002;
    visibility: hidden;
}
.arrBox_h:before {
    content: "";
    border-style: solid;
    border-width: 10px;
    width: 0;
    height: 0;
    position: absolute;
}
.arrBox_h:after{
    content: "";
    border-style: solid;
    border-width: 10px;
    width: 0;
    height: 0;
    position: absolute;
}
.arrBox_h:before, .arrow-up:before {
    border-color: transparent transparent #e6dede;
}
.arrowBox:after, .arrBox_h:after, .arrow-up:after {
    margin-top: 1px;
    border-color: transparent transparent #fff;
}
.textColor{color: rgba(3, 2, 26, 0.5);}
.brandImage img{height:86px !important;
max-height: 120px;}

.shopcart-icon:before {
    content: "\f12e";
    font-family: Flaticon;
    font-size: 26px;
    font-weight: normal;
    position: relative;
    top: -5px;
}
.heightCos{height:404px;}
.trendingLink{ margin-bottom:5px;
		font-weight:400;
		color: rgba(3, 2, 26, 0.5);		 
    opacity: 0.5;
}

</style>
